// SMS text rules for per-keystroke counters, which have to run in the
// browser: copies of smsview.Segments, campaigns.ComposeSMS, and
// campaigns.CollapseSMSSignOff. One copy of each, so every counter agrees
// with the others. The alphabet and the four segment boundaries arrive as
// data attributes (components.SMSEncodingAttrs), so the copies can drift
// on the logic but never on the numbers.

// Mirrors campaigns.CollapseSMSSignOff.
export function collapseSignOff(raw) {
  return raw.replace(/[\p{Cc}\p{White_Space}]+/gu, " ").trim();
}

// Mirrors campaigns.ComposeSMS with the footer on.
export function composeSMS(body, signOff, footer) {
  const text = body.trim();
  if (!text) return text;
  if (!signOff) return text.includes(footer) ? text : `${text} ${footer}`;

  const signed = `${text}\n${signOff}`;

  return signed.includes(footer) ? signed : `${signed}\n${footer}`;
}

export function smsEncoding(dataset) {
  const gsmSingle = Number(dataset.segmentSize) || 160;
  const gsmMulti = Number(dataset.segmentSizeMulti) || 153;
  const ucs2Single = Number(dataset.segmentSizeUcs2) || 70;
  const ucs2Multi = Number(dataset.segmentSizeUcs2Multi) || 67;
  const gsmBasic = dataset.gsmBasic || "";
  const gsmExtended = dataset.gsmExtended || "";

  // One character outside the GSM-7 alphabet re-encodes the whole text
  // as UTF-16, where less than half as much fits in a segment.
  const encodedUnits = (text) => {
    let septets = 0;
    let gsm = true;

    for (const char of text) {
      if (gsmBasic.includes(char)) septets += 1;
      else if (gsmExtended.includes(char)) septets += 2;
      else gsm = false;
    }
    if (gsm) return { units: septets, gsm };

    // .length is UTF-16 code units, which is what the carrier counts.
    return { units: text.length, gsm };
  };

  const singleSize = (gsm) => (gsm ? gsmSingle : ucs2Single);

  // Takes encodedUnits' result, so a caller that shows both the length
  // and the count scans the text once.
  const segmentsFor = (units, gsm) => {
    if (units === 0) return 0;
    if (units <= singleSize(gsm)) return 1;

    return Math.ceil(units / (gsm ? gsmMulti : ucs2Multi));
  };

  const segments = (text) => {
    const { units, gsm } = encodedUnits(text);

    return segmentsFor(units, gsm);
  };

  return { encodedUnits, segments, segmentsFor, singleSize };
}
